import React, { useEffect, useState } from "react";
import "./BuyerForm.css";
import BASE_URL from "../config";

const BuyerForm = () => {
  const [formData, setFormData] = useState({
    advertiserEmail: "",
    targetId: "",
    buyerEmail: "",
  });

  // Fetch values from URL
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    const advertiserEmail =
      params.get("advertiserEmail");

    const targetId =
      params.get("targetId");

    setFormData((prev) => ({
      ...prev,
      advertiserEmail:
        advertiserEmail || "",

      targetId: targetId || "",
    }));
  }, []);

  // Handle Input Change
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  // Submit Form
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(
        `${BASE_URL}/api/create-invitation`,
        {
          method: "POST",
          headers: {
            "Content-Type":
              "application/json",
          },

          body: JSON.stringify({
            advertiser_email:
              formData.advertiserEmail,

            buyer_email:
              formData.buyerEmail,

            tagetname:
              formData.targetId,
          }),
        }
      );

      const data = await response.json();

      if (data.success) {
        alert(
          "Invitation sent successfully"
        );

        setFormData((prev) => ({
          ...prev,
          buyerEmail: "",
        }));
      } else {
        alert(data.message);
      }

    } catch (error) {
      console.log(error);

      alert("Something went wrong");
    }
  };

  return (
    <div className="container">
      <div className="form-card">

        <h2>Buyer Invitation</h2>

        <form onSubmit={handleSubmit}>

          {/* Advertiser Email */}
          <div className="form-group">

            <label>
              Advertiser Email
            </label>

            <input
              type="email"
              name="advertiserEmail"
              value={
                formData.advertiserEmail
              }
              readOnly
            />
          </div>

          {/* Target ID */}
          <div className="form-group">

            <label>
              Target ID
            </label>

            <input
              type="text"
              name="targetId"
              value={formData.targetId}
              readOnly
            />
          </div>

          {/* Buyer Email */}
          <div className="form-group">

            <label>
              Buyer Email
            </label>

            <input
              type="email"
              name="buyerEmail"
              placeholder="Enter buyer email"
              value={formData.buyerEmail}
              onChange={handleChange}
              required
            />
          </div>

          <button
            type="submit"
            className="submit-btn"
          >
            Submit
          </button>

        </form>
      </div>
    </div>
  );
};

export default BuyerForm;